<template>
  <b-modal
    id="modalInfo"
    v-model="isOpen"
    modal-class="modalInfo"
    size="lg"
    :title="
      $t('label_evaluation_evidencesRequested_use_already_submitted_evidence')
    "
  >
    <div>
      <span>
        {{
          $t(
            "label_evaluation_evidencesRequested_evidencesRelated_lightbox_select"
          )
        }}
      </span>
      <div style="margin-top: 20px">
        <b-input-group>
          <template #append>
            <span
              ><icon class="fa-icon-nuevo" name="search" aria-hidden="true"
            /></span>
          </template>
          <b-form-input v-model="search" />
        </b-input-group>
      </div>
      <div class="scroll" style="padding: 20px; text-align: left">
        <b-form-radio-group>
          <b-form-radio
            v-for="(evidence, index) in filteredItems"
            :key="index"
            v-model="selected"
            style="margin-top: 10px; width: 100%"
            name="checkbox"
            :value="evidence"
            :unchecked-value="false"
          >
            <div>{{ evidence.title }}</div>
            <a style="color: blue; cursor: pointer" target="_blank">
              ({{ evidence.name }})</a
            >
          </b-form-radio>
        </b-form-radio-group>
      </div>
    </div>
    <div slot="modal-footer" class="w-100" style="text-align: center">
      <div class="d-flex justify-content-around">
        <b-row>
          <b-col>
            <b-btn @click="isOpen = false">
              {{
                $t(
                  "label_evaluation_requirementEvaluation_evidenceResubmission_warning_cancel"
                )
              }}
            </b-btn>
          </b-col>
          <b-col>
            <b-btn variant="primary" @click="selectItems()">
              {{
                $t(
                  "label_evaluation_requirementEvaluation_evidenceResubmission_warning_send"
                )
              }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "SelectEvidenceModal",
  props: [
    "showModal",
    "selectedEvidence",
    "evaluationId",
    "evidences",
    "requirement",
  ],
  data() {
    return {
      search: "",
      selected: null,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.$emit("update:showModal", newValue);
      },
    },
    filteredItems() {
      if (this.evidences && this.evidences.length) {
        let notSelectedEvidences = this.evidences.filter(
          (evidence) =>
            !(evidence.requirements || []).find(
              (requirement) =>
                requirement.requirementId.toString() ===
                this.requirement.id.toString()
            )
        );

        return notSelectedEvidences.filter((item) => {
          if (typeof item.name !== "undefined") {
            return (
              item.title.match(this.search) || item.name.match(this.search)
            );
          } else {
            return item.title.match(this.search);
          }
        });
      } else {
        return [];
      }
    },
  },
  methods: {
    selectItems() {
      this.$emit("update:selectedEvidence", this.selected);
      this.isOpen = false;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../assets/css/variables.scss"

.scroll
    height:500px
    overflow-y: scroll
</style>
